module.exports = __webpack_public_path__ + "img/Med-Eng.a40e4037.jpg";